module.exports = __webpack_public_path__ + "static/ceo-5752c8c3552913fd5bee8ed0b20507ff.jpg";